

import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";
const AkornServiceFees = () => {
    const fileName = 'Akorn Service Fees';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const columns = [
		{
			Header: "Contract Reference",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "Shipped Quantity",
			accessor: "ShippedQuantity",
			filter: "ShippedQuantity",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Shipped Measurement Code",
			accessor: "ShippedMeasurementCode",
			filter: "ShippedMeasurementCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Shipped Time",
			accessor: "ShippedTime",
			filter: "ShippedTime",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Invoice Number #",
			accessor: "InvoiceNumber",
			filter: "InvoiceNumber",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Ship From Name",
			accessor: "ShipFromName",
			filter: "ShipFromName",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "Ship To Name",
			accessor: "ShipToName",
			filter: "ShipToName",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "Ship From CustomerID ",
			accessor: "ShipFromCustomerID",
			filter: "ShipFromCustomerID",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Ship To CustomerID",
			accessor: "ShipToCustomerID",
			filter: "ShipToCustomerID",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Vendor CustomerID",
			accessor: "VendorCustomerID",
			filter: "VendorCustomerID",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Total Invoice Amount",
			accessor: "TotalInvoiceAmount",
			filter: "TotalInvoiceAmount",
			sortType: "basic",
			width: 80,
		},

		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Quantity Invoiced",
			accessor: "QuantityInvoiced",
			filter: "QuantityInvoiced",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Invoiced Unit Measurement Code",
			accessor: "InvoicedUnitMeasurementCode",
			filter: "InvoicedUnitMeasurementCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Invoiced Unit Price",
			accessor: "InvoicedUnitPrice",
			filter: "InvoicedUnitPrice",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Invoiced Unit Price Code",
			accessor: "InvoicedUnitPriceCode",
			filter: "InvoicedUnitPriceCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Buyer Part Number",
			accessor: "BuyerPartNumber",
			filter: "BuyerPartNumber",
			sortType: "basic",
			width: 150,
		},

		{
			Header: "Vendor Part Number",
			accessor: "VendorPartNumber",
			filter: "VendorPartNumber",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "UPC",
			accessor: "UPC",
			filter: "UPC",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Pack",
			accessor: "Pack",
			filter: "Pack",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Size",
			accessor: "Size",
			filter: "Size",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Packaging Code",
			accessor: "PackagingCode",
			filter: "PackagingCode",
			sortType: "basic",
			width: 80,
		},
	];

	useEffect(() => {
		getAdvanceShipNotice();
	}, []);

	async function getAdvanceShipNotice() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const salesResult = data.data;
				if (salesResult.length > 0) {
					salesResult.map((res) => {
						res.ShippedDate = moment(res.ShippedDate).format("MM/DD/YYYY");
					});
				}
				setSales(salesResult);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	const EnableAddEdit = () => {
		localStorage.setItem("salesData", JSON.stringify(sales));
		history.push("/SalesEdiAddEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">Akorn Service Fees</h2>
				{loading ? <Loader /> : null}
				<div>
					{sales.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Edit Records
							</Button>
						))}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(columns, sales, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load Akorn Service Fees.</p>
								) : (
									<Fragment>
										{sales.length > 0 ? (
											<ReactTable
												columns={columns}
												data={sales}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);

}

export default AkornServiceFees;